import { render, staticRenderFns } from "./Dark.vue?vue&type=template&id=58ae962f&"
import script from "./Dark.vue?vue&type=script&lang=js&"
export * from "./Dark.vue?vue&type=script&lang=js&"
import style0 from "./Dark.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports